export default "__VITE_ASSET__0qZdM$fa__"